@let u = user();
@let tabList = tabs();
@let active = activeKind();
@let s = stats();
@let v = verdict();
@let stepList = steps();
<div class="scrim" (click)="closed.emit()"></div>
<section
  class="sheet"
  role="dialog"
  aria-modal="true"
  [attr.aria-label]="'Stream Stats' | translate">
  <header class="sheet-header">
    <h3>
      <fa-duotone-icon [icon]="faChartSimple"></fa-duotone-icon>
      <span class="title">{{ isSelf() ? ('Your Stream' | translate) : u?.data?.name }}</span>
      <span class="direction">{{ (isSelf() ? 'Sending' : 'Receiving') | translate }}</span>
    </h3>
    <button
      type="button"
      class="close-btn"
      [attr.aria-label]="'Close' | translate"
      (click)="closed.emit()">
      <fa-duotone-icon [icon]="faXmark"></fa-duotone-icon>
    </button>
  </header>

  @if (tabList.length > 1) {
    <div class="tabs" role="tablist">
      @for (tab of tabList; track tab.kind) {
        <button
          type="button"
          role="tab"
          [attr.aria-selected]="tab.kind === active"
          (click)="selectTab(tab.kind)">
          <fa-icon [icon]="tab.kind === 'screen' ? faDisplay : faVideo"></fa-icon>
          {{ (tab.kind === 'screen' ? 'Screen' : 'Camera') | translate }}
        </button>
      }
    </div>
  }

  @if (chips().length) {
    <div class="chips">
      @for (chip of chips(); track chip.text) {
        <span class="chip" [class]="'chip--' + chip.kind">{{ chip.text }}</span>
      }
    </div>
  }

  @if (stepList.length) {
    <ol class="strip">
      @for (step of stepList; track step.label; let i = $index) {
        @if (i > 0) {
          <li class="edge" [class.edge--ok]="edgeOk(stepList, i)" aria-hidden="true"></li>
        }
        <li class="step" [class]="'step--' + step.status" tabindex="0">
          <span class="dot">
            @switch (step.status) {
              @case ('done') {
                <fa-icon [icon]="faCheck"></fa-icon>
              }
              @case ('warn') {
                <fa-icon [icon]="faExclamation"></fa-icon>
              }
              @case ('failed') {
                <fa-icon [icon]="faXmarkSolid"></fa-icon>
              }
            }
          </span>
          <span class="step-label">{{ step.label | translate }}</span>
          <span class="step-details" role="tooltip">
            <span class="step-details-title">{{ step.label | translate }}</span>
            @for (d of step.details; track d.label) {
              <span class="step-detail">
                <span>{{ d.label | translate }}</span>
                <span>{{ d.value | translate }}</span>
              </span>
            }
          </span>
        </li>
      }
    </ol>
  }

  @if (v) {
    <div class="verdict" [class]="'verdict--' + v.severity">
      <fa-icon
        [icon]="v.severity === 'error' ? faTriangleExclamation : faCircleExclamation"></fa-icon>
      <span>{{ v.key | translate: v.params }}</span>
    </div>
  }

  @if (s) {
    <div class="graphs">
      @for (g of graphs(); track g.label) {
        <andor-stats-graph
          [label]="g.label | translate"
          [series]="g.series"
          [cap]="g.cap"
          [digits]="g.digits"
          [tone]="g.tone"></andor-stats-graph>
      }
    </div>
    <dl class="rows">
      @for (row of rows(); track row.k) {
        <div class="row">
          <dt>{{ row.k | translate }}</dt>
          <dd>{{ row.v }}</dd>
        </div>
      }
    </dl>
  } @else {
    <p class="empty">
      {{
        (sourceOk() === false ? 'No stats are available for this stream.' : 'Waiting for stats…')
          | translate
      }}
    </p>
  }

  <div class="actions">
    <andor-button color="neutral" (click)="copyDiagnostics()">
      <fa-icon class="copy-icon" [icon]="faCopy"></fa-icon>
      <span>{{ (copied() ? 'Copied!' : 'Copy Diagnostics') | translate }}</span>
    </andor-button>
  </div>
</section>
